import * as TenantsConstants from "../constants/Tenants";

const initialState = {
  collection: [],
  pagination: {
    total: 0,
    perPage: 10,
    totalPages: 0,
    page: 0
  },
  sorting: {
    sort: 'asc',
    order: 'id',
    query: ''
  },
  reindexing: [],
  isFetching: false,
  currentTenant: null,
  isFetchingTenant: false
};

export function manage_tenants(state = initialState, action) {
  switch (action.type) {
    case TenantsConstants.FETCH_TENANT_STARTED:
      return Object.assign({}, state, {isFetchingTenant: true, currentTenant: null});
    case TenantsConstants.FETCH_TENANT_COMPLETED:
      return Object.assign({}, state, {isFetchingTenant: false, currentTenant: action.tenant});
    case TenantsConstants.FETCH_TENANTS_STARTED:
      return Object.assign({}, state, {
        isFetching: true
      });
    case TenantsConstants.FETCH_TENANTS_COMPLETED:
      return Object.assign({}, state, {
        collection: action.tenants,
        pagination: action.pagination,
        sorting: action.sorting,
        isFetching: false
      });
    case TenantsConstants.REINDEX_TENANT_STARTED: {
      const reindexingTenants = [...state.reindexing];
      reindexingTenants[action.id] = true;
      return Object.assign({}, state, {
        reindexing: reindexingTenants
      });
    }

    case TenantsConstants.REINDEX_TENANT_COMPLETED: {
      const reindexingTenants = [...state.reindexing];
      reindexingTenants[action.id] = false;
      return Object.assign({}, state, {
        reindexing: reindexingTenants
      });
    }
    case TenantsConstants.UPDATE_TENANT_STARTED:
      return Object.assign({}, state, {isFetchingTenant: true});
    case TenantsConstants.UPDATE_TENANT_COMPLETED:
      return Object.assign({}, state, {isFetchingTenant: false, currentTenant: action.tenant});
    default:
      return state;
  }
}
